import Handlebars from "handlebars";

Handlebars.registerHelper("iconSpriteUrl", function () {
  return window.SparkleConfig.assetPaths.svgIconSprite;
});
